export default class GameflowHelper {
  construction() {}
  static action(func, lastFor) {
    //fire an action and specify how long it takes.
    //use case: do nth and last for 2 seconds for another view logic.
    return new Promise((resolve, reject) => {
      func();
      setTimeout(() => {
        resolve(true);
      }, lastFor);
    });
  }
}
